import {InitPage} from "../index";

declare var App: any;

class ExternalMessageAlert {
    cdmChannel: any;

    constructor() {
        this.cdmChannel = App.cable.subscriptions.create(
            // Connection configuration
            {
                channel: "CdmChannel"
            },
            // Pass in connection callbacks
            {
                connected() { /* */ },
                disconnected() { /* */ },
                received: (data: any) => this.onNewexternalMessage(data)
            }
        );
    }

    onNewexternalMessage(data) {
        const li = $("<li></li>");
        li.html(data["message_body"]);
        $("#external-messages").prepend(li);
    }
}

export function LoadPage() {
    InitPage("chat", () => {
        const m = new ExternalMessageAlert();
    });
}
